import { useQuery } from 'react-query';
import axiosConn from '../axiosConn';

const fetchPosts = async ({ queryKey }) => {
  // console.log(playerId);
  const [
    _,
    player,
    playerId,
    page,
    endpoint,
    galaxyId,
    fetchAll,
    radius,
    unit,
    latitude,
    longitude,
  ] = queryKey;
  // console.log('radius', radius, 'unit', unit);

  // console.log('endpoint', endpoint);
  // Check for valid latitude, longitude, and radius
  if (
    fetchAll &&
    endpoint !== 'galaxyPosts' && // Only check for latitude and longitude if fetchAll is true and endpoint is not 'galaxyPosts'
    (latitude === null ||
      longitude === null ||
      isNaN(latitude) ||
      isNaN(longitude) ||
      radius === null ||
      radius === '' ||
      isNaN(radius))
  ) {
    console.error('Invalid latitude, longitude, or radius. Skipping API call.');
    return []; // Return an empty array to avoid breaking the app
  }

  try {
    let res;
    if (playerId && endpoint !== 'galaxyPosts') {
      res = await axiosConn.get(
        `posts/profile/${playerId}${page ? `?page=${page}` : ''}`,
        {
          headers: {
            Authorization: `Bearer ${player.token}`,
          },
        },
      );
      res.data = res.data.filter((post) => !post.galaxyId);
      // console.log(res.data);
    } else if (endpoint === 'galaxyPosts') {
      res = await axiosConn.get(
        `galaxies/${galaxyId}/posts/${page ? `?page=${page}` : ''}`,
        {
          headers: {
            Authorization: `Bearer ${player.token}`,
          },
        },
      );
      // console.log(res.data.posts);
    } else if (fetchAll) {
      res = await axiosConn.get(
        `posts/timeline/${player.data.player._id}/location/${radius}/${unit}/center/${latitude}/${longitude}
        `,
        {
          headers: {
            Authorization: `Bearer ${player.token}`,
          },
        },
      );
      res.data = res.data.filter((post) => !post.galaxyId);
      // console.log(res.data.length);
    } else {
      const qs = page ? `?page=${page}&pageSize=20` : '?pageSize=20';
      res = await axiosConn.get(
        `posts/timeline/${player.data.player._id}${qs}`,
        {
          headers: {
            Authorization: `Bearer ${player.token}`,
          },
        },
      );
      res.data = res.data.filter((post) => !post.galaxyId);
      // console.log(res.data);
    }
    // Return res.data.posts if endpoint is 'galaxyPosts', otherwise return res.data
    return endpoint === 'galaxyPosts' ? res.data.posts : res.data;
  } catch (err) {
    console.log(err);
  }
};

export const useGetPosts = (
  onSuccess,
  onError,
  player,
  playerId,
  page,
  endpoint = 'posts',
  galaxyId = null,
  fetchAll = false,
  radius = null,
  unit = 'mi',
  latitude = null,
  longitude = null,
) => {
  // Add galaxyId parameter with default value
  return useQuery(
    [
      'getPosts',
      player,
      playerId,
      page,
      endpoint,
      galaxyId,
      fetchAll,
      radius,
      unit,
      latitude,
      longitude,
    ],
    fetchPosts,
    {
      // Add galaxyId to queryKey
      onSuccess,
      onError,
      keepPreviousData: true,
      refetchOnWindowFocus: fetchAll ? true : false,
      staleTime: Infinity, // Prevent data from being marked as stale
      refetchInterval: false, // Disable periodic background refetching
    },
  );
};
